
import React, { useEffect } from 'react';
import './steps.scss';


const Steps = ({activeKeyIndex, keys}) => {

  useEffect(()=>{
    for(let i=activeKeyIndex; i>=0; i--) {
      const curKey = keys[i]['id'];
      const keyElement = document.getElementById(curKey);
      keyElement.className = keyElement.className + ' active'
    }

    for(let i=keys.length-1;i>=1;i--){
      const curKey = keys[i]['id'];
      const keyElement = document.getElementById(curKey);
      keyElement.className = keyElement.className + ' branch';
    }
  })

  const renderLogo = (index, data) => {
    if(Object.keys(data).includes('logo')){
      if(activeKeyIndex<index) {
        return (
          <img src={data['logo']['inactive']}/>
        )
      } else {
        return (
          <img src={data['logo']['active']}/>
        )
      }
    }
  }

  const renderSteps = () => {
    /* Group unique keys */
    let keyHeaders = [];
    for(var index in keys) {
      if(!keyHeaders.some(data=>data.id.includes(keys[index].id))) {
        keyHeaders.push(keys[index]);
      }
    }
    return (
      <React.Fragment>
        {
          keyHeaders.map((data, index)=>{
            return (
              <div key={index}>
                <div className="step" id={index}>
                  <div className="logo" id={data['id']}>
                    { renderLogo(index, data) }
                  </div>
                </div>
                {data['name']}
              </div>
            )
          })
        }
      </React.Fragment>
    )
  }

  return (
    <div id="step-parent" className="steps">
      { renderSteps() }
    </div>
  )
}

export default Steps;



